/**
 * Format of responses from server with multiple values.
 */
export interface ListResponseContract<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: Array<T>;
}
